export default __webpack_public_path__ + "static/media/Santa-blowing.e312f464.png";